// 로그인 감지를 위한 공용 헬퍼 | 250905 | smyun
// 백에서 내려주는 TK 쿠키가 있으면 로그인

export const COOKIE_KMTK = "KMTK";
const AUTH_BC = "auth-channel";
const AUTH_LS_KEY = "auth:event";

export type AuthEvent = "login" | "logout";

// 쿠키 읽기 (document.cookie 직접 파싱)
function hasCookie(name: string): boolean {
    if (typeof document === "undefined") return false;
    return document.cookie.split(";").some((c) => c.trim().startsWith(name + "="));
}

// ✅ 로그인 여부(boolean)
export function isLoggedIn(): boolean {
    return hasCookie(COOKIE_KMTK);
}

// 탭 간 동기화용
export function emitAuthEvent(ev: AuthEvent) {
    const payload = { ev, ts: Date.now() };
    localStorage.setItem(AUTH_LS_KEY, JSON.stringify(payload));
    try {
        const bc = new BroadcastChannel(AUTH_BC);
        bc.postMessage(payload);
        bc.close();
    } catch {}
}
